import api from './APIInterceptor'

export default class NewsService {
  static getNews() {
    return api.get('/news')
  }
}
